import { gql } from '@apollo/client';

import { CategoryFragment, ProductsFragment } from './categoryFragments.gql';

export const createCategoryQuery = (queryName = 'GetCategories') => gql`
    query ${queryName}(
        $id: String!
        $pageSize: Int!
        $currentPage: Int!
        $filters: ProductAttributeFilterInput!
        $sort: ProductAttributeSortInput
    ) {
        categories(filters: { category_uid: { in: [$id] }, }) {
            items {
                uid
                ...CategoryFragment
            }
        }
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            filter: $filters
            sort: $sort
        ) {
            ...ProductsFragment
        }
    }
    ${CategoryFragment}
    ${ProductsFragment}
`;

export const GET_CATEGORY = gql`
  query GetCategoriesv3(
    $id: String!
    $pageSize: Int!
    $currentPage: Int!
    $filters: ProductAttributeFilterInput!
    $sort: ProductAttributeSortInput
  ) {
    categories(filters: { category_uid: { in: [$id] } }) {
      items {
        uid
        ...CategoryFragment
      }
    }
    products(pageSize: $pageSize, currentPage: $currentPage, filter: $filters, sort: $sort) {
      ...ProductsFragment
    }
  }
  ${CategoryFragment}
  ${ProductsFragment}
`;

export const GET_PRODUCT_FILTERS_BY_CATEGORY = gql`
  query getProductFiltersByCategory(
    $categoryIdFilter: FilterEqualTypeInput! # $productColor: FilterEqualTypeInput
  ) {
    products(filter: { category_uid: $categoryIdFilter }) {
      aggregations {
        label
        count
        attribute_code
        options {
          label
          value
          count
          swatch_data {
            value
          }
        }
        position
      }
    }
  }
`;

export const GET_CATEGORY_CONTENT = gql`
  query getCategoryData($id: String!) {
    categories(filters: { category_uid: { in: [$id] } }) {
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      items {
        uid
        name
        description
        url_key
        url_path
        seo_rich_snippets
      }
    }
  }
`;

export const GET_CATEGORY_AVAILABLE_SORT_METHODS = gql`
  query getCategoryAvailableSortMethods($categoryIdFilter: FilterEqualTypeInput!) {
    products(filter: { category_uid: $categoryIdFilter }) {
      sort_fields {
        options {
          label
          value
        }
      }
    }
  }
`;

export const GET_CURRENCY = gql`
  query getCurrencyData {
    currency {
      current_currency_code @client
      default_display_currency_code
      available_currency_codes
    }
  }
`;
export const GET_CATEGORY_DATA_CACHE = `
    query getCategoryDataCache(
        $id: String!
        $pageSize: Int!
        $currentPage: Int!
        $filters: ProductAttributeFilterInput!
        $sort: ProductAttributeSortInput
    ) {
        categories(filters: { category_uid: { in: [$id] }, }) {
            items {
                uid
                url_key
                name
                adv(currentPage: $currentPage) {
                  id
                  title
                  img
                  m_img
                  link
                  page
                  position
                }
            }
        }
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            filter: $filters
            sort: $sort
        ) {
      items {
            id
            uid
            name
            serial_name
            product_mark
            show_colorsV1(width: 680, height: 860) {
              label
              rgb
              is_selected
              image
              hover_image
            }
            price_range {
              maximum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
                discount {
                  amount_off
                }
              }
              minimum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
                discount {
                  amount_off
                }
              }
            }
            video_url
            prices {
              finalPrice {
                currency
                value
              }
              regularPrice {
                currency
                value
              }
              # ChildrenPrices {
              #     child_product_id
              #     sku
              #     finalPrice {
              #         currency
              #         value
              #     }
              #     regularPrice {
              #         currency
              #         value
              #     }
              # }
            }
            # presale_product {
            #     status
            #     label
            #     note
            # }
            sku
            hover_image(width: 680, height: 860)
            small_image {
              url(type: "thumbnail", width: 680, height: 860)
            }
            stock_status
            rating_summary
            review_count
            __typename
            url_key
            ... on ConfigurableProduct {
              # eslint-disable-next-line @graphql-eslint/require-id-when-available
              configurable_options {
                attribute_code
                attribute_id
                uid
                label
                product_id
                # eslint-disable-next-line @graphql-eslint/require-id-when-available
                values {
                  uid
                  default_label
                  label
                  store_label
                  use_default_value
                  value_index
                  swatch_data {
                    ... on ImageSwatchData {
                      thumbnail
                    }
                    value
                  }
                }
              }
              # variants {
              #     attributes {
              #         code
              #         value_index
              #     }
              #     # eslint-disable-next-line @graphql-eslint/require-id-when-available
              #     product {
              #         id
              #         uid
              #         presale_product {
              #             status
              #             label
              #             note
              #         }
              #         sku
              #         stock_status
              #     }
              # }
            }
          }
          page_info {
            total_pages
            current_page
          }
          total_count
        }
    }
`;
export default {
  getCategoryContentQuery: GET_CATEGORY_CONTENT,
  getCategoryQuery: GET_CATEGORY,
  getProductFiltersByCategoryQuery: GET_PRODUCT_FILTERS_BY_CATEGORY,
  getCategoryAvailableSortMethodsQuery: GET_CATEGORY_AVAILABLE_SORT_METHODS,
  getCategoryDataCacheQuery: GET_CATEGORY_DATA_CACHE,
};
